export function UpdateObject(event, setObject) {
	const { name, value, type, checked } = event.target;
	setObject(prev => ({
		...prev,
		[name]: type === 'checkbox' ? checked : value,
	}));
}